const fmt = require("indian-number-format");

export default function UserCard(props) {
  const item = props.item;

  // 🔹 Format with + / - sign
  const formatAmountPlusM = (value) => {
    const num = parseFloat(value) || 0;
    const sign = num > 0 ? "+" : num < 0 ? "-" : "";
    return `${sign}${fmt.format(Math.abs(num))}`;
  };
  const formatAmountMinesP = (value) => {
    const num = parseFloat(value) || 0;
    const sign = num < 0 ? "+" : num > 0 ? "-" : "";
    return `${sign}${fmt.format(Math.abs(num))}`;
  };

  return (
    <div className="menuContainer bg-[var(--background)] text-[var(--text)] addHight">
      
      <div className="menuExchange text-[var(--text)] uppercase">
        {item.username}
      </div>

      <div className={`menuExchange uppercase ${item.booked > 0 ? "buytext" : "selltext"}`}>
        {formatAmountPlusM(item.booked)}
      </div>

      <div className={`menuExchange uppercase ${item.m2m > 0 ? "buytext" : "selltext"}`}>
        {formatAmountPlusM(item.m2m)}
      </div>

      <div className="menuExchange uppercase buytext">
        {formatAmountPlusM(item.commission)}
      </div>

      <div className="menuExchange uppercase buytext">
        {formatAmountPlusM(item.broker_commission)}
      </div>

      <div className={`menuExchange uppercase ${item.total < 0 ? "buytext" : "selltext"}`}>
        {formatAmountMinesP(item.total)}
      </div>

      <div className={`menuExchange uppercase ${item.bb_sharing < 0 ? "buytext" : "selltext"}`}>
        {item.bb_sharing}%
      </div>

      <div className={`menuExchange uppercase ${item.broker_total < 0 ? "buytext" : "selltext"}`}>
        {formatAmountMinesP(item.broker_total)}
      </div>

      <div className={`menuExchange uppercase ${item.master_total < 0 ? "buytext" : "selltext"}`}>
        {formatAmountMinesP(item.master_total)}
      </div>

    </div>
  );
}
